export enum ProfileStatus {
  //
  PENDING = 'PENDING',
  VERIFIED = 'VERIFIED',
  ACTIVATED = 'ACTIVATED',
  REJECTED = 'REJECTED',
  BLOCKED = 'BLOCKED',
}
